<template>
<div role="textbox" contenteditable type="text"
	:class="{'error-text': limitReached}"
	@blur="focusOut()"
	@input="input($event)"
	@keydown.enter.exact.prevent
	@keyup.enter.exact="submit($event)"
	v-text="value"
/>
</template>

<script>

function removeAllChildNodes( parent ){
	while( parent.firstChild ){
		parent.removeChild( parent.firstChild )
	}
}

export default {
	props: {
		value: String,
		limitValue: {
			type: Number,
			default: 250
		}
	},
	data: () => ({
		limitReached: false
	}),
	methods: {
		focusOut(){
			if( this.$el.textContent.trim().length === 0 ){
				removeAllChildNodes( this.$el )
			}
		},
		input( ev ){
			if( ev.target.innerText.length > this.limitValue ){
				console.log( 'limitReached' )
				this.limitReached = true
			} else {
				this.limitReached = false
			}
			//ev.target.value = this.$el.textContent.trim()
			ev.target.value = ev.target.innerHTML.trim()
		},
		submit( ev ){
			ev.target.blur()
		}
	}
}
</script>